import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import css from './Start.module.css';

/**
 * Closing links to find care or apply as a provider.
 */
const Start = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <p className={css.eyebrow}>
        <FormattedMessage id="AboutStart.eyebrow" defaultMessage="Get started" />
      </p>
      <h2 className={css.title}>
        <FormattedMessage id="AboutStart.title" defaultMessage="Find the care you need" />
      </h2>
      <p className={css.text}>
        <FormattedMessage id="AboutStart.text" defaultMessage="Or share the expertise you have" />
      </p>
      <div className={css.actions}>
        <NamedLink className={css.primary} name="SearchPage">
          <FormattedMessage id="AboutStart.browse" defaultMessage="Find care" />
        </NamedLink>
        <NamedLink
          className={css.secondary}
          name="SignupForUserTypePage"
          params={{ userType: 'provider' }}
        >
          <FormattedMessage id="AboutStart.apply" defaultMessage="Join as a provider" />
        </NamedLink>
      </div>
    </div>
  </section>
);

export default Start;
